import { useMemo } from 'react';

import map from 'lodash/map';

import { useShiftTypesGet } from '@sbv-clients/data-access-api';
import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import { useAppendAllOption } from './util';
import useAutoSelectValue from './util/use-auto-select-value';

export function ShiftTypeFilter({
  withAllOption = false,
  autoSelectIfEmpty = false,
  useContextFn,
  errorMessages = {},
}: {
  withAllOption?: boolean;
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    shiftTypeId: number;
    onChangeShiftTypeId: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { data = [], isLoading, isSuccess } = useShiftTypesGet();
  const { shiftTypeId: value, onChangeShiftTypeId: onChange } = useContextFn();
  const options = useMemo(
    () =>
      map(data, (item) => ({
        id: String(item.shiftTypeId),
        label: item.shiftTypeName ?? '',
        value: item.shiftTypeId as number,
      })),
    [data]
  );
  useAppendAllOption(options, withAllOption);
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess,
  });
  const handleChange = useTransformSelectValue(onChange);
  const helperText = errorMessages['shiftTypeId'];
  return (
    <Select
      isLoading={isLoading}
      fullWidth
      size="small"
      value={value}
      label="Shift Type"
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
      hideStartAdornment={isLoading}
    />
  );
}
